import React from "react";
import { KPIValueFormat } from "../types";
import { InsFormattedNumeral } from "components/widgets/base";
export const KpiValue = (props) => {
    switch (props.format) {
        case KPIValueFormat.amount:
            return React.createElement(InsFormattedNumeral, { value: props.value.value, maximumSignificantDigits: 3, minimumSignificantDigits: 3 });
        case KPIValueFormat.value:
            return React.createElement(InsFormattedNumeral, { value: props.value.value, maximumSignificantDigits: 3, minimumSignificantDigits: 1 });
        case KPIValueFormat.percent:
            return React.createElement("div", { className: "value" },
                props.value.formattedValue.slice(0, -1),
                React.createElement("span", { className: "unit" }, "%"));
        case KPIValueFormat.multiple:
            return React.createElement("div", { className: "value" },
                props.value.formattedValue.slice(0, -1),
                React.createElement("span", { className: "unit" }, "X"));
        case KPIValueFormat.string:
            return React.createElement("div", { className: "string-value" }, props.value.formattedValue);
        case KPIValueFormat.number:
            return React.createElement("div", { className: "value" }, props.value.formattedValue);
        case KPIValueFormat.date:
            return React.createElement("div", { className: "value" }, props.value.formattedValue);
        case KPIValueFormat.area:
            return React.createElement("div", { className: "value" }, props.value.formattedValue.split(" ")[0]);
        case KPIValueFormat.unit:
            return React.createElement(InsFormattedNumeral, { value: props.value.value, maximumSignificantDigits: 3, minimumSignificantDigits: 3 });
        default:
            return React.createElement(React.Fragment, null, props.value.formattedValue);
    }
};
